<template>
    <div class="container live-form">
        <div class="common-header-wrap">
            <mt-header :title="getTitle" class="common-header">
                <mt-button slot="left" icon="back" @click="goBack"></mt-button>
            </mt-header>
        </div>
        <div class="notice">
            <span>Anchor micro signal needs face authentication</span>
            <mt-button class="btn" @click="showQrcode=true" size="small" type="primary"><span>Certification</span></mt-button>
        </div>
        <mt-field :disabled="minipro_live_info.minipro_live_room_id" class="menu-item" label="Live title" v-model="minipro_live_info.minipro_live_name" />
        <div @click="minipro_live_info.minipro_live_room_id?'':onTimeOpen('start')"><mt-cell title="Start time" is-link>{{minipro_live_start_time?$moment.unix(minipro_live_start_time).format('YYYY-MM-DD HH:mm'):''}}</mt-cell></div>
        <div @click="minipro_live_info.minipro_live_room_id?'':onTimeOpen('end')"><mt-cell title="End Time" is-link>{{minipro_live_end_time?$moment.unix(minipro_live_end_time).format('YYYY-MM-DD HH:mm'):''}}</mt-cell></div>
        <mt-field class="menu-item" label="Anchor nickname" :disabled="minipro_live_info.minipro_live_room_id" v-model="minipro_live_info.minipro_live_nickname" />
        <mt-field class="menu-item" label="Anchor Wechat Code" :disabled="minipro_live_info.minipro_live_room_id" v-model="minipro_live_info.minipro_live_wxid" />
        <mt-cell class="pt-5" title="Live cover">
            <div class="user-avatar-wrapper">
                <div v-if="minipro_live_info.feedsImg" class="user-avatar">
                    <img :src="minipro_live_info.feedsImgUrl">
                    <span @click="minipro_live_info.minipro_live_room_id?'':dropImage('feedsImg')" class="del-btn iconfont">&#xe6d8;</span>
                </div>
                <div v-else class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadImage('feedsImg',$event)">
                    <div class="center-text">Picture below 1MB（800*640px）</div>
                    <input :disabled="minipro_live_info.minipro_live_room_id" type="file" accept="image/*">
                </div>
            </div>
        </mt-cell>
        <mt-cell class="pt-5" title="Live background">
            <div class="user-avatar-wrapper">
                <div v-if="minipro_live_info.coverImg" class="user-avatar">
                    <img :src="minipro_live_info.coverImgUrl">
                    <span @click="minipro_live_info.minipro_live_room_id?'':dropImage('coverImg')" class="del-btn iconfont">&#xe6d8;</span>
                </div>
                <div v-else class="user-avatar iconfont icon-xiangji" ref="upload_btn1" @change="uploadImage('coverImg',$event)">
                    <div class="center-text">Picture below 2MB（1080*1920px）</div>
                    <input :disabled="minipro_live_info.minipro_live_room_id" type="file" accept="image/*">
                </div>
            </div>
        </mt-cell>
        <div @click="popupSelect = true">
            <mt-cell title="Select product" is-link>{{selectGoodsId.length?(selectGoodsId.length + ' selected'):''}}</mt-cell>
        </div>
        <mt-popup v-model="popupSelect" position="right" class="common-popup-wrapper" :modal="false">
            <div class="common-header-wrap">
                <mt-header title="Select product" class="common-header">
                    <mt-button slot="left" icon="back" @click.native="popupSelect = false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content">
                <div v-infinite-scroll="loadMore" infinite-scroll-disabled="loading" infinite-scroll-distance="10">
                    <div class="select-goods" v-if="selectGoodsList">
                        <ul v-if="selectGoodsList.length">
                            <li v-for="item in selectGoodsList" v-bind:key="item.goods_commonid" :class="{'active':item.minipro_live_goods_info && selectGoodsId.indexOf(item.minipro_live_goods_info.minipro_live_goods_result_id)>-1,'disable':!item.minipro_live_goods_info || item.minipro_live_goods_info.minipro_live_goods_state!=2 || item.minipro_live_goods_info.minipro_live_goods_close==1}" @click="selectedGoods(item)">
                                <div class="p-img">
                                    <img :src="item.goods_image_url"/>
                                </div>
                                <div class="p-info">
                                    <p class="name">{{item.goods_name}}</p>
                                    <p class="price">{{item.goods_price}}</p>
                                </div>
                                <div v-if="item.minipro_live_goods_info && item.minipro_live_goods_info.minipro_live_goods_close==1" class="state">
                                    <span>Closed</span>
                                </div>
                                <div v-else class="state">
                                    <span v-if="!item.minipro_live_goods_info || !item.minipro_live_goods_info.minipro_live_goods_state">Under review</span>
                                    <span v-if="item.minipro_live_goods_info && item.minipro_live_goods_info.minipro_live_goods_state==2">Passed</span>
                                    <span v-if="item.minipro_live_goods_info && item.minipro_live_goods_info.minipro_live_goods_state==3">Failed</span>
                                </div>
                            </li>
                        </ul>
                        <empty-record v-else></empty-record>
                    </div>
                </div>
            </div>
        </mt-popup>
        <mt-button class="ds-button-large" type="primary"  v-on:click="submit">Save</mt-button>
        <mt-datetime-picker
                :closeOnClickModal="false"
                ref="startTimePicker"
                type="datetime"
                :startDate="new Date()"
                yearFormat="{value}-"
                monthFormat="{value}-"
                dateFormat="{value} "
                hourFormat="{value}:"
                minuteFormat="{value}"
                :value="minipro_live_start_time?(new Date(minipro_live_start_time)):(new Date())"
                @confirm="onTimeConfirm('start',$event)"
        >
        </mt-datetime-picker>
        <mt-datetime-picker
                :closeOnClickModal="false"
                ref="endTimePicker"
                type="datetime"
                :startDate="new Date()"
                yearFormat="{value}-"
                monthFormat="{value}-"
                dateFormat="{value} "
                hourFormat="{value}:"
                minuteFormat="{value}"
                :value="minipro_live_end_time?(new Date(minipro_live_end_time)):(new Date())"
                @confirm="onTimeConfirm('end',$event)"
        >
        </mt-datetime-picker>
        <!--认证小程序码-->
        <mt-popup v-model="showQrcode" position="right" class="common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="Authentication Mini Program Code" class="common-header">
                    <mt-button slot="left" icon="back" @click="showQrcode=false"></mt-button>
                </mt-header>
            </div>
            <div class="common-popup-content" style="text-align: center">
                <img class="refer_qrcode_logo" src="../../../assets/image/minipro_live_verify.png">
            </div>
        </mt-popup>
        <mt-popup position="right" v-model="showCrop" class="crop-wrapper common-popup-wrapper">
            <div class="common-header-wrap">
                <mt-header title="Crop the picture" class="common-header">
                    <mt-button slot="left" icon="back" @click="showCrop=false"></mt-button>
                    <mt-button slot="right" @click="useCrop">Use</mt-button>
                </mt-header>
            </div>
            <vue-cropper class="common-popup-content" style="height: auto;position: absolute" ref="cropper" :maxImgSize="cropperOption.maxImgSize" :autoCropWidth="cropperOption.autoCropWidth" :autoCropHeight="cropperOption.autoCropHeight" :autoCrop="cropperOption.autoCrop" :img="cropperOption.img" :canMove="cropperOption.canMove" :outputType="cropperOption.outputType"></vue-cropper>
        </mt-popup>
    </div>
</template>

<script>
import { VueCropper } from 'vue-cropper'
import { Toast, Indicator } from 'mint-ui'
import { getRoomInfo, addRoom, uploadMedia, getGoodsList, importRoomGoods } from '../../../api/sellerMiniproLive'
import EmptyRecord from '../../../components/EmptyRecord'
export default {
  components: {
    EmptyRecord,
    VueCropper
  },
  props: {
    ifComponent: {
      type: Boolean,
      default: false
    },
    query: {
      type: Object,
      default: function () {
        return { action: 'add', minipro_live_id: 0 }
      }
    }
  },
  computed: {
    isAddMode () {
      let mode = this.ifComponent ? this.query.action : this.$route.query.action
      // add: 添加地址，edit: 编辑地址
      if (mode === 'add') {
        return true
      } else {
        return false
      }
    },
    getTitle () {
      if (this.isAddMode) {
        return 'New live broadcast'
      } else {
        return 'Modify live broadcast'
      }
    }

  },
  data () {
    return {
      cropperOption: {
        img: '',
        canMove: false,
        autoCrop: true,
        autoCropWidth: 100,
        autoCropHeight: 100,
        maxImgSize: 500,
        outputType: 'png'
      },
      showCrop: false,
      cropType: '',
      showQrcode: false,
      minipro_live_start_time: 0,
      minipro_live_end_time: 0,
      minipro_live_info: {},
      popupSelect: false,
      params: { 'page': 0, 'per_page': 10 },
      loading: false, // 是否加载更多
      isMore: true, // 是否有更多
      selectGoodsList: false,
      selectGoodsId: [],
      keyword: '',
      showimage: '',
      isshow: false
    }
  },
  created: function () {
    this.initLive()
  },
  watch: {
    query: function (val) {
      this.minipro_live_id = val.minipro_live_id
      this.initLive()
    }
  },
  methods: {
    goBack () {
      if (this.ifComponent) {
        this.$emit('closeLiveApplyForm')
      } else {
        this.$router.go(-1)
      }
    },
    initLive () {
      if (!this.isAddMode) {
        getRoomInfo(this.minipro_live_id).then(res => {
          var minipro_live_info = res.result.minipro_live_info
          this.minipro_live_start_time = minipro_live_info.minipro_live_start_time
          this.minipro_live_end_time = minipro_live_info.minipro_live_end_time
          this.minipro_live_info = minipro_live_info
        }).catch(function (error) {
          Toast(error.message)
        })
      }
    },
    onTimeConfirm (type, value) {
      if (type == 'start') {
        this.minipro_live_info.minipro_live_start_time = parseInt(value.getTime() / 1000)
        this.minipro_live_start_time = this.minipro_live_info.minipro_live_start_time
      } else {
        this.minipro_live_info.minipro_live_end_time = parseInt(value.getTime() / 1000)
        this.minipro_live_end_time = this.minipro_live_info.minipro_live_end_time
      }
    },
    onTimeOpen (type) {
      if (type == 'start') {
        this.$refs.startTimePicker.open()
      } else {
        this.$refs.endTimePicker.open()
      }
    },
    submit () {
      Indicator.open()
      addRoom(this.minipro_live_info).then(res => {
        this.minipro_live_info.minipro_live_room_id = res.result.roomId
        if (this.selectGoodsId.length) {
          this.importRoomGoods(res.result.roomId)
        } else {
          this.finish()
        }
        Indicator.close()
      }).catch(error => {
        Indicator.close()
        Toast(error.message)
      })
    },
    finish () {
      Indicator.close()
      if (this.ifComponent) {
        this.$emit('addRoom')
      } else {
        this.$router.push({ name: 'SellerMiniproLiveList' })
      }
    },
    importRoomGoods (roomId) {
      importRoomGoods({ roomId: roomId, ids: this.selectGoodsId }).then(res => {
        this.finish()
      }).catch(error => {
        Indicator.close()
        Toast(error.message)
      })
    },
    loadMore () {
      this.loading = true
      this.params.page = ++this.params.page
      if (this.isMore) {
        this.loading = false
        this.getSelectGoodsList(true)
      }
    },
    reload () {
      // 重新加载数据
      this.params.page = 0
      this.isMore = true
      this.selectGoodsList = []
      this.loadMore()
    },
    // 获取商品列表 用于设置产品分佣
    getSelectGoodsList () {
      getGoodsList(this.params).then(res => {
        if (this.selectGoodsList) {
          this.selectGoodsList = this.selectGoodsList.concat(res.result.goods_list)
        } else {
          this.selectGoodsList = res.result.goods_list
        }
        if (res.result.hasmore) {
          this.isMore = true
        } else {
          this.isMore = false
        }
      }).catch(function (error) {
        Toast(error.message)
      })
    },
    // 选择商品
    selectedGoods (item) {
      if (item.minipro_live_goods_info && item.minipro_live_goods_info.minipro_live_goods_state == 2 && item.minipro_live_goods_info.minipro_live_goods_close != 1) {
        var index = this.selectGoodsId.indexOf(item.minipro_live_goods_info.minipro_live_goods_result_id)
        if (index > -1) {
          this.selectGoodsId.splice(index, 1)
        } else {
          if (this.selectGoodsId.length >= 10) {
            Toast('Choose up to 10 items')
            return
          }
          this.selectGoodsId.push(item.minipro_live_goods_info.minipro_live_goods_result_id)
        }
      }
    },
    openImage (src) {
      this.showimage = src
      this.isshow = true
    },
    dropImage (type) {
      if (type == 'feedsImg') {
        this.minipro_live_info.feedsImg = ''
      } else {
        this.minipro_live_info.coverImg = ''
      }
      this.$forceUpdate()
    },
    useCrop () {
      let type = this.cropType
      this.$refs.cropper.getCropBlob(res => {
        let files = new window.File([res], 'temp.png', { type: res.type })
        let formdata = new FormData()

        formdata.append('file', files)
        formdata.append('name', 'file')
        if (type == 'feedsImg') {
          formdata.append('save', 1)
        }
        Indicator.open()
        uploadMedia(formdata).then(res => {
          if (type == 'feedsImg') {
            this.minipro_live_info.feedsImg = res.result.media_id
            this.minipro_live_info.minipro_live_image = res.result.file_name
          } else {
            this.minipro_live_info.coverImg = res.result.media_id
          }

          this.showCrop = false
          Indicator.close()
        }).catch(function (error) {
          Toast(error.message)
          Indicator.close()
        })
      })
    },
    uploadImage (type, event) {
      let that = this
      this.cropType = type
      let file = event.target.files[0]
        if (!/\.(jpg|png|gif|bmp|jpeg)$/.test(file.name.toLowerCase())) {
            Toast('Please upload the file in picture format')
            return
        }
      let reader = new FileReader()
      let rs = reader.readAsDataURL(file)
      reader.onload = (e) => {
        that.cropperOption.img = e.target.result
        if (type == 'feedsImg') {
          that.minipro_live_info.feedsImgUrl = e.target.result
        } else {
          that.minipro_live_info.coverImgUrl = e.target.result
        }
        that.$forceUpdate()
        let image = new Image()
        image.src = e.target.result
        image.onload = function () {
          that.cropperOption.autoCropWidth = window.screen.width
          that.cropperOption.autoCropHeight = this.height / this.width * window.screen.width
          that.cropperOption.maxImgSize = window.screen.height - 40
          that.showCrop = true
          that.$forceUpdate()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
    .select-goods li{height:3rem;padding:.6rem;display:flex;}
    .select-goods li.active{background: rgba(255, 203, 203, 0.5) }
    .select-goods li .p-img{}
    .select-goods li .p-img img{width:3rem;height: 3rem;}
    .select-goods li .p-info{margin-left:1rem;flex:1}
    .select-goods li .p-info p{line-height:1rem;}
    .select-goods li .p-info .price{font-size:0.6rem;color:$primaryColor;height:2rem;overflow: hidden}
    .select-goods li .p-info .name{font-size:0.7rem;}
    .select-goods li .state{font-size: .7rem}
    .select-goods li.disable{position: relative;opacity: .5}
    .user-avatar-wrapper{display: inline-block;vertical-align: top;margin-right: .5rem;margin-bottom:.5rem}
    .user-avatar-wrapper .del-btn{position:absolute;bottom:.2rem;right:.2rem}
    .user-avatar {
        display: block;
        border:1px solid #eee;
        position: relative;
        width: 5rem;
        height: 5rem;
        margin: 0 auto;
        text-align: center;
        img,video {
            width: 100%;
            height: 100%
        }
        input {
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            opacity: 0
        }
        .center-text{padding:.2rem;padding-top:3.5rem;font-size:.6rem}
        /*.desc-text{font-size: .5rem;color: #999}*/
    }
    .user-avatar::before {
        position: absolute;
        font-size: 1.5rem;
        line-height: 5rem;
        left: 50%;
        margin-left: -.75rem;
        color: rgba(0, 0, 0, 0.5)
    }
    .notice{font-size:.7rem;padding:.5rem;background:#FCF8E3;color:#C09853;line-height: 1.65rem;
        .red{color:#F00}
        .btn{float:right}
    }
    .refer_qrcode_logo{width:60%;top:30%;position: relative;}
</style>
